import { useEffect, useRef, useState } from "react";
import { Box, HStack, Icon, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";

import {
  setDateRange,
  updateReportRange,
} from "../../store/actions/defaultAction";

import { REPORT_RANGES } from "../../store/constants";
import {
  getDefaultDateRangeForReportRange,
  getDefaultReportLinkForRange,
  getReportRangeFromPathname,
} from "../../store/reportRangeRoutes";

const OrganizationSelection = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { reportRange, organizationId, dateRange } = useSelector(
    (store) => store.defaultReducer
  );
  const pendingRangeNavigation = useRef(null);
  const [showSelect, setShowSelect] = useState(!reportRange.length ? 1 : 0);

  const reportRangeStr = {
    month: "Monthly",
    week: "Weekly",
    day: "Daily",
    realtime: "Realtime",
    ticket_info: "Ticket Information",
  }[reportRange];

  useEffect(() => {
    const routeReportRange = getReportRangeFromPathname(pathname);
    const defaultDateRange = getDefaultDateRangeForReportRange(reportRange);

    if (pendingRangeNavigation.current === reportRange) {
      pendingRangeNavigation.current = null;
      dispatch(setDateRange(defaultDateRange));
      navigate(getDefaultReportLinkForRange(reportRange));
      return;
    }

    if (routeReportRange && routeReportRange !== reportRange) {
      dispatch({
        type: "UPDATE_REPORT_RANGE",
        payload: routeReportRange,
      });
      dispatch(setDateRange(getDefaultDateRangeForReportRange(routeReportRange)));
      return;
    }

    if (routeReportRange && !dateRange.length) {
      dispatch(setDateRange(defaultDateRange));
    }
  }, [dateRange.length, dispatch, navigate, pathname, reportRange]);

  const selectReportRange = (nextReportRange) => {
    pendingRangeNavigation.current = nextReportRange;
    dispatch(updateReportRange(nextReportRange));
    setShowSelect(0);
  };

  return organizationId.length ? (
    <Box>
      <Box
        h="40px"
        lineHeight="40px"
        bg="var(--blue)"
        borderRadius="20px"
        padding="0 20px"
      >
        <HStack
          justifyContent="space-between"
          alignItems="center"
          onClick={() => setShowSelect(!showSelect)}
        >
          <Text
            as="label"
            color="var(--white)"
            fontSize="14px"
            fontWeight={600}
          >
            {reportRange.length && reportRangeStr
              ? reportRange === REPORT_RANGES.TICKET_INFO
                ? reportRangeStr
                : reportRangeStr + " Reports"
              : "Select Report Range"}
          </Text>
          <Icon
            as={showSelect ? IoChevronUpOutline : IoChevronDownOutline}
            boxSize="16px"
            color="var(--white)"
          />
        </HStack>
      </Box>
      <Box
        bg="#f7f7f7"
        borderRadius="5px"
        fontSize="14px"
        overflow="auto"
        mt="10px"
        display={showSelect ? "block" : "none"}
      >
        <Box
          p="10px 10px"
          _hover={{ background: "#ececec" }}
          cursor="pointer"
          onClick={() => {
            if (reportRange !== REPORT_RANGES.MONTH) {
              selectReportRange(REPORT_RANGES.MONTH);
            } else {
              setShowSelect(0);
            }
          }}
        >
          Monthly
        </Box>
        <Box
          p="10px 10px"
          _hover={{ background: "#ececec" }}
          cursor="pointer"
          onClick={() => {
            selectReportRange(REPORT_RANGES.WEEK);
          }}
        >
          Weekly
        </Box>
        <Box
          p="10px 10px"
          _hover={{ background: "#ececec" }}
          cursor="pointer"
          onClick={() => {
            selectReportRange(REPORT_RANGES.DAY);
          }}
        >
          Daily
        </Box>

        <Box
          p="10px 10px"
          _hover={{ background: "#ececec" }}
          cursor="pointer"
          onClick={() => {
            selectReportRange(REPORT_RANGES.RT);
          }}
        >
          Realtime
        </Box>

        <Box
          p="10px 10px"
          _hover={{ background: "#ececec" }}
          cursor="pointer"
          onClick={() => {
            selectReportRange(REPORT_RANGES.TICKET_INFO);
          }}
        >
          Ticket Information
        </Box>
      </Box>
    </Box>
  ) : null;
};

export default OrganizationSelection;
